import cn from 'clsx';
import React, { FC, HTMLAttributes, memo, PropsWithoutRef, ReactNode, RefAttributes } from 'react';

import GuideButtonArea from './ButtonArea/GuideButtonArea';
import GuideDescription from './Description/GuideDescription';
import s from './Guide.module.scss';
import GuideImageArea from './ImageArea/GuideImageArea';
import GuideTextArea from './TextArea/GuideTextArea';
import GuideTitle from './Title/GuideTitle';
import { GuideProvider } from './context';

interface GuideProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  isCard?: boolean;
}

const Guide: FC<React.PropsWithChildren<React.PropsWithChildren<GuideProps>>> = React.forwardRef<HTMLDivElement, GuideProps>((guideProps, ref) => {
  const { children, isCard = false, className = '', ...props } = guideProps;
  return (
    <GuideProvider
      value={{
        isCard
      }}
    >
      <div className={cn(s.guide, isCard && s.guide__isCard, className)} {...props} ref={ref}>
        {children}
      </div>
    </GuideProvider>
  );
});

type GuideComponent<T, P> = React.ForwardRefExoticComponent<PropsWithoutRef<P> & RefAttributes<T>> & {
  TextArea: typeof GuideTextArea;
  ImageArea: typeof GuideImageArea;
  ButtonArea: typeof GuideButtonArea;
  Title: typeof GuideTitle;
  Description: typeof GuideDescription;
};

const MemoGuide = memo(Guide);
export default MemoGuide as GuideComponent<HTMLDivElement, GuideProps>;
